<template>
    <q-input
        :placeholder="$t('shared.Search by language code')"
        v-model="filterPhrase"
        dense
        outlined
        class="q-ma-sm dropdown-search-field"
        data-qs="language-search-field"
    >
        <template #prepend>
            <q-icon name="fa-regular fa-magnifying-glass" />
        </template>
    </q-input>
    <q-list>
        <q-item
            v-for="language in filteredLanguages"
            :key="language"
            clickable
            v-close-popup
            @click="selectLanguage(language)"
            class="default-text-color items-center"
            :data-qs="`dropdown-item-${language}`"
            :class="{ 'language-active': language.toLowerCase() === currentLanguage.toLowerCase() }"
        >
            {{ `${languageMapping[language]} (${language})` }}
        </q-item>
    </q-list>
</template>
<script setup lang="ts">
import { getAvailableLanguages, getUiLanguage, setUiLanguage } from "@/shared/services/providers/language-provider.ts";
import { computed, ref } from "vue";

const filterPhrase = ref("");
const currentLanguage = computed(() => getUiLanguage());
const languageMapping: Record<string, string> = {
    DE: "Deutsch",
    EN: "English",
    FR: "Français",
    IT: "Italiano",
    ES: "Español",
    ZH: "中文",
    JA: "日本語",
};

const switchLanguage = (language: string) => {
    const selectedLanguage = language.toLowerCase();
    if (selectedLanguage && selectedLanguage !== currentLanguage.value) {
        setUiLanguage(selectedLanguage);
    }
};
const selectLanguage = (language: string) => {
    switchLanguage(language);
};

const availableLanguages = computed(() => getAvailableLanguages().map((locale) => locale.toUpperCase()));
const filteredLanguages = computed(() =>
    filterPhrase.value
        ? availableLanguages.value.filter((language) => {
              return language.toLowerCase().startsWith(filterPhrase.value.toLowerCase());
          })
        : availableLanguages.value
);
</script>

<style lang="scss" scoped>
.language-active {
    background-color: var(--q-highlight);
}
</style>
